import filesStore from './modules/files';
import jobsStore from './modules/jobs';
import messagesStore from './modules/messages';
import searchStore from './modules/search';
import notificationsStore from './modules/notifications';
import whatsNew from './modules/whats-new';

export default {
  namespaced: true,
  modules: {
    filesStore,
    jobsStore,
    messagesStore,
    searchStore,
    notificationsStore,
    whatsNew,
  },
};
